import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("albion_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const gbp = (v) => `£${Number(v || 0).toFixed(2)}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d?.msg || d);
}

export const imgSrc = (url) => (url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export const STATUS_LABELS = {
  paid: "Order received",
  shopping: "Shopping at store",
  shipped: "Shipped with Evri",
  delivered: "Delivered",
  cancelled: "Cancelled",
  awaiting_payment: "Awaiting payment",
};

export const CATEGORIES = ["Luxury Chocolate", "Chocolate Biscuits", "Christmas Treats", "Tins & Selection Boxes", "Christmas Biscuits", "Biscuits & Crackers", "Snacks & Sweets", "Tea & Coffee", "Pantry Essentials", "Healthy Snacks"];
export const STORES = ["Marks & Spencer", "Waitrose", "Tesco", "Sainsbury's"];


export const toApiItems = (items) =>
  items.map((i) => (i.hamper ? { hamper: i.hamper, qty: i.qty } : { product_id: i.id, qty: i.qty }));
